export const PermissionStatus = {
  GRANTED: "granted",
  DENIED: "denied",
  UNDETERMINED: "undetermined",
}

export async function requestPermissionsAsync() {
  return { granted: true, status: PermissionStatus.GRANTED }
}

export async function getPermissionsAsync() {
  return { granted: true, status: PermissionStatus.GRANTED }
}

export async function createAssetAsync(uri: string) {
  return { uri }
}

export async function saveToLibraryAsync() {}

export async function getAssetInfoAsync() {
  return { localUri: "", uri: "" }
}

export function addListener(_event: string, _cb: () => void) {
  return { remove: () => {} }
}

export function removeSubscription(_sub: { remove: () => void }) {
  _sub?.remove?.()
}

export async function presentPermissionsPickerAsync() {}

export default {
  PermissionStatus,
  requestPermissionsAsync,
  getPermissionsAsync,
  createAssetAsync,
  saveToLibraryAsync,
}
